import { CompartmentCard } from "@/src/components/cards";
import { openDrawer } from "@/src/components/dialogs";
import { FetchableList } from "@/src/components/fetchableLists";
import { FolderItem, Patient, PatientDocument } from "@/src/data/allTypes";
import { USER } from "@/src/data/globalVariables";

import apiFetch from "@/src/utils/apiFetch";
import { uid } from "@/src/utils/utils";
import React from "react";
import { DocumentTile } from "../documents/documentsCompartment";
import {
  getAllServiceDocumentTemplates,
  openDocumentForm,
  openEditor,
} from "../documents/documentsHook";
import { DocumentTemplateChoiceList } from "../documents/documentTemplates";

function DocumentsHistory({
  patient,
  parent,
}: {
  patient: Patient;
  parent: FolderItem | null | undefined;
}) {
  const [reload, setReload] = React.useState(0);

  async function choseDocumentTemplate({ patient }: { patient: Patient }) {
    await openDrawer({
      id: "documentTemplateChoiceDrawer",
      title: "Choisir un modèle de document",
      content: (
        <DocumentTemplateChoiceList
          types={["standard", "letter"]}
          onSelect={async (template) => {
            let patientDocument: PatientDocument = {
              patient: patient,
              creator: USER?.get(),
              status: "pending",
              template: template,
              parent,
              content: template.content,
              title: template.title || "Nouveau document",
              refAnswer: {
                creator: USER?.get(),
                reference: template.reference,
                patient: patient,
                fieldAnswers: [],
                notes: "",
                conclusion: "",
                
              },
            };

            await openDocumentForm({
              patient,
              patientDocument,
            });
          }}
        />
      ),
      footer: <div></div>,
    });
  }

  async function loadMore() {
    console.log(
      "loadmeore tempalteIds",
      getAllServiceDocumentTemplates({
        unitType: "medecineLegale",
      })?.map((template) => template?.id || "")
    );
    return await apiFetch(
      "patientDocuments",
      "loadMany",
      {
        patientId: patient.id,
        parentId: parent?.id,
        excludedTemplatesIds: getAllServiceDocumentTemplates({
          unitType: "medecineLegale",
        })?.map((template) => template?.id || ""),
      },
      "Erreur lors du chargement des documents"
    );
  }

  return (
    <CompartmentCard
      title={"Documents"}
      color="green"
      onClick={async () => {
        await choseDocumentTemplate({ patient });
        setReload(reload + 1);
      }}
    >
      <FetchableList
        queryKey={["patientDocuments", patient.id, parent?.id, reload]}
        queryFn={loadMore()}
      >
        {(patientDocuments) => (
          <div className="c1 gap10">
            {patientDocuments?.map((patientDocument, index) => {
              return (
                <DocumentTile
                  key={uid()}
                  patientDocument={patientDocument}
                  onEdit={async () => {
                    let fullPatientDocument = await apiFetch(
                      "patientDocuments",
                      "loadOne",
                      {
                        id: patientDocument?.id,
                      },
                      "Erreur lors du chargement du document"
                    );
                    if (!fullPatientDocument)
                      throw new Error("Le Document n'existe pas.");
                    await openDocumentForm({
                      patient,
                      patientDocument: fullPatientDocument,
                      onChange: () => {
                        setReload(reload + 1);
                      },
                    });
                  }}
                  onClick={async () => {
                    let fullPatientDocument = await apiFetch(
                      "patientDocuments",
                      "loadOne",
                      {
                        id: patientDocument?.id,
                      },
                      "Erreur lors du chargement du document"
                    );
                    if (!fullPatientDocument)
                      throw new Error("Le Document n'existe pas.");
                    openEditor({
                      patient,
                      patientDocument: fullPatientDocument,
                      onChange: () => {
                        setReload(reload + 1);
                      },
                    });
                  }}
                  onDelete={async () => {
                    await apiFetch(
                      "patientDocuments",
                      "deleteOne",
                      {
                        id: patientDocument.id,
                      },
                      "Erreur lors de la suppression du document"
                    );
                    setReload(reload + 1);
                  }}
                ></DocumentTile>
              );
            })}
          </div>
        )}
      </FetchableList>
    </CompartmentCard>
  );
}

export { DocumentsHistory };
